import React, { Fragment } from 'react';
import { LogoutOutlined } from '@ant-design/icons';
import TokenManager from '../../utils/TokenManager';
import { logoutFromToken } from '../../api/Header';
import './style.scss';
const Logout = () => {
  const doLogout = () => {
    logoutFromToken().then(() => {
      console.info("Token Invalidated from API!!!");
    }).finally(() => {
      TokenManager.clearTokenDetails();
      TokenManager.clearAllCookies();
    });
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
    id: "logout-btn",
    className: "tap-logout-btn hidden-mobile",
    onClick: doLogout,
    type: "button"
  }, __('Logout')), /*#__PURE__*/React.createElement("div", {
    className: "tap-logout hidden-desktop"
  }, /*#__PURE__*/React.createElement(LogoutOutlined, {
    onClick: doLogout
  })));
};
export default Logout;